import { Button } from 'react-bootstrap';
import { Tooltip } from 'components/Common/Tooltip/Tooltip';
import Icon from 'components/Icons/Icon';
import Loading from "components/Loading";

const EditModeHtml = ({ editMode, toggleEditMode, utilities = [], loadingSubmitEdit, disableEditButton, setAlternateEditStyle, additionalStyling = "" }) => {
  const showMenu = utilities.length > 0;

  const toggleEditModeHandler = () => {
    toggleEditMode();
    setAlternateEditStyle(false);
  }

  return (
    <div className={`edit-mode-toolbar-container ${editMode ? "visible" : ""} ${disableEditButton ? "disabled" : ""} ${loadingSubmitEdit ? "loading-border" : ""} ${additionalStyling}`}>
      {loadingSubmitEdit ? 
        (<Loading />)
      : 
        (
          <>
            {showMenu &&
              <div className={`edit-mode-toolbar ${editMode ? "visible" : ""} ${loadingSubmitEdit ? "px-0" : ""}`}>
                <div className={`edit-mode-toolbar-inner ${loadingSubmitEdit ? "px-0" : ""}`}>
                  {utilities.map(({ key, Component, props }) => (
                    <div key={key} className="edit-mode-utility-button">
                      <Component {...props} />
                    </div>
                  ))}
                </div>
              </div>
            }

            <Tooltip
              placement="top"
              description={`${editMode ? disableEditButton ? "Complete or cancel current process before Editing" : "View" : "Edit"}`}
            >
              <Button
                variant="primary"
                className={disableEditButton ? "" : `edit-button${showMenu ? "-menu" : ""}${editMode ? "-enabled" : ""}`}
                onClick={disableEditButton ? () => "" : toggleEditModeHandler}
                data-intercom-target={"edit-view-button"}
              >
                <Icon className={`fas fa-${editMode ? disableEditButton ? "lock" : "unlock" : "lock"}`} />
              </Button>
            </Tooltip>
          </>
        )
      }
    </div>
  )
}

export default EditModeHtml;